import React from 'react';
import { FeaturePageLayout } from '@/components/shared/FeaturePageLayout';
import { Gift } from 'lucide-react';

export default function TrialSupportPage() {
  return (
    <FeaturePageLayout
      icon={Gift}
      title="Trial Support"
      badge="Onboarding Feature"
      description="Experience the full power of Agentick with our 7-day free trial. Get dedicated onboarding support, full platform access, and hands-on guidance — absolutely free, no credit card required."
      capabilities={[
        {
          title: 'Full Platform Access',
          description: 'No feature restrictions during your trial. Experience every capability Agentick offers — AI agent, knowledge base, lead capture, and more.',
        },
        {
          title: 'Guided Onboarding',
          description: 'Step-by-step setup assistance to get your AI agent live within minutes. We walk you through every configuration.',
        },
        {
          title: 'No Credit Card Required',
          description: 'Start your trial without entering payment information. Zero risk, zero commitment — just test and experience.',
        },
        {
          title: 'Sample Knowledge Base',
          description: 'We provide industry-specific starter templates for your knowledge base so you can see results immediately.',
        },
        {
          title: 'Dedicated Support Channel',
          description: 'Get priority access to our support team during the trial. Ask questions, get help, and ensure a smooth experience.',
        },
        {
          title: 'Seamless Upgrade',
          description: 'When your trial ends, upgrade to a paid plan in one click. All your data, configurations, and conversations are preserved.',
        },
      ]}
      howItWorks={[
        {
          title: 'Sign Up in 30 Seconds',
          description: 'Enter your name, email, and phone number. No credit card, no lengthy forms. You are in.',
        },
        {
          title: 'Follow the Setup Wizard',
          description: 'Our guided wizard walks you through creating your first AI agent, connecting WhatsApp, and uploading knowledge.',
        },
        {
          title: 'Test with Real Conversations',
          description: 'Send test messages to your AI agent on WhatsApp. See how it handles queries, uses your knowledge base, and captures leads.',
        },
        {
          title: 'Upgrade or Walk Away',
          description: 'After 7 days, choose a plan that fits your needs. If Agentick is not for you, simply walk away — no questions asked.',
        },
      ]}
      useCases={[
        { emoji: '🚀', title: 'Startup Validation', description: 'Test if WhatsApp AI suits your business before investing. Validate your customer communication strategy.' },
        { emoji: '🔄', title: 'Platform Comparison', description: 'Compare Agentick with your current solution side-by-side during the free trial period.' },
        { emoji: '👥', title: 'Team Evaluation', description: 'Let your team test the platform hands-on before making a company-wide adoption decision.' },
        { emoji: '📊', title: 'ROI Assessment', description: 'Measure real response times, customer satisfaction, and workload reduction during the trial.' },
        { emoji: '🎯', title: 'Use Case Discovery', description: 'Explore different automation scenarios — support, sales, FAQ — to find your highest-value use case.' },
        { emoji: '🤝', title: 'Stakeholder Demo', description: 'Use the trial to create a live demo for decision-makers. Show real results, not slide decks.' },
      ]}
      ctaText="Start your free 7-day trial now"
    />
  );
}
